export { View as Tab2012 } from './view'
